import PropCardImpl from './prop-card.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const { UIView } = MojitoCore.Presentation;

/**
 * Prop card component.
 *
 * @function PropCard
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.Prop
 */

/**
 * Prop card controller prop types.
 *
 * @property {object} card - Prop card promotion. Its content holds the event, market and selection ids, the jersey image and the per-card colours.
 * @property {boolean} [shouldRequestData = true] - Whether the card requests its event and market data.
 *
 * @memberof Mojito.Modules.EventCards.Prop.view
 */
const propTypes = {
    card: PropTypes.object,
    shouldRequestData: PropTypes.bool,
};

const defaultProps = {
    shouldRequestData: true,
};

export default UIView('PropCard', PropCardImpl, propTypes, defaultProps);
